import {openOverlayMenu, openOverlaySubmenu, fixedNavbar} from './sections/navigation';
import './groupeFilter';
import {teaserModal, videoModal, spaceModal, heroVideoModal, teamModal} from "@scripts/components/modal";
import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';

import Facets from './components/facets';
/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */


window.addEventListener('DOMContentLoaded', function() {
  let searchButton = document.getElementById('openSearchModal');
  let closeSearch = document.getElementById('closeModalButtonSearch');
  searchButton.addEventListener('click', function() {
    let searchModal = document.getElementById('search-modal');
    document.body.classList.add('fixed')
    searchModal.classList.add('is-open');
  })
  closeSearch.addEventListener('click', function() {
    let searchModal = document.getElementById('search-modal');
    document.body.classList.remove('fixed')
    searchModal.classList.remove('is-open')
  })

   new Swiper('.swiper-container', {
     pagination: {
       el: '.swiper-pagination',
       clickable: true,
     },
     navigation: {
       nextEl: ".swiper-button-next",
       prevEl: ".swiper-button-prev",
     },
     autoplay: {
       delay: 3500,
       disableOnInteraction: false,
       pauseOnMouseEnter: true,
     },
     modules: [Navigation, Pagination, Autoplay],
  });
})
window.addEventListener('scroll', fixedNavbar)
window.addEventListener('DOMContentLoaded', openOverlayMenu)
window.addEventListener('DOMContentLoaded', openOverlaySubmenu)
window.addEventListener('DOMContentLoaded', fixedNavbar)
window.addEventListener('DOMContentLoaded', teaserModal)
window.addEventListener('DOMContentLoaded', videoModal)
window.addEventListener('DOMContentLoaded', spaceModal)
window.addEventListener('DOMContentLoaded', teamModal)
window.addEventListener('DOMContentLoaded', heroVideoModal)
window.addEventListener('DOMContentLoaded', function() {
  let container = document.querySelectorAll('.container')[0]
  let widthContainer = container.clientWidth
  let windowWidth = document.body.clientWidth
  let containerStyle = window.getComputedStyle(container)
  let paddingContainer = parseFloat(containerStyle.paddingLeft)

  let margin = windowWidth - widthContainer - (paddingContainer * 2)

  document.documentElement.style.setProperty('--margin-container', margin+ "px")
})

const swiper = new Swiper('.swiper', {
  slidesPerView:1,
  spaceBetween: 20,

  breakpoints: {
    320: {
      slidesPerView: 1.7
    },
    640: {
      slidesPerView: 2.7
    },
    1070: {
      slidesPerView: 3.2
    }
  }

});

window.addEventListener('DOMContentLoaded', function() {
  let scrollToNextBlock = document.getElementById('scrollToNextBlock');

  if(scrollToNextBlock) {
    scrollToNextBlock.addEventListener('click', function(e) {
      e.preventDefault();

      window.scrollBy({
        top: window.innerHeight,
        behavior: 'smooth'
      });
    })
  }
});

// Dropdown "Ajouter au calendrier"
window.addEventListener('DOMContentLoaded', function() {
  var toggle = document.querySelector('.calendar-dropdown-toggle');
  var menu = document.querySelector('.calendar-dropdown-menu');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', function(e) {
    e.stopPropagation();
    toggle.classList.toggle('open');
    menu.classList.toggle('open');
  });

  document.addEventListener('click', function() {
    toggle.classList.remove('open');
    menu.classList.remove('open');
  });
});
